import React from 'react';
import PropTypes from 'prop-types';

const PauseIcon = ({ className }) => {
  return (
    <svg 
    width="28" 
    height="28" 
    viewBox="0 0 28 28" 
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
    fill="currentColor" // Ensures the color can be changed dynamically
    >
    <path d="M12.425 22.295V5.705C12.425 4.13 11.76 3.5 10.08 3.5H5.845C4.165 3.5 3.5 4.13 3.5 5.705V22.295C3.5 23.87 4.165 24.5 5.845 24.5H10.08C11.76 24.5 12.425 23.87 12.425 22.295Z" fill="currentColor"/>
    <path d="M24.5002 22.295V5.705C24.5002 4.13 23.8352 3.5 22.1552 3.5H17.9202C16.2519 3.5 15.5752 4.13 15.5752 5.705V22.295C15.5752 23.87 16.2402 24.5 17.9202 24.5H22.1552C23.8352 24.5 24.5002 23.87 24.5002 22.295Z" fill="currentColor"/>
    </svg>
    
  );
};

PauseIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

PauseIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default PauseIcon;